module.exports = __webpack_public_path__ + "static/media/image_53.1722929c.png";